module.exports = "<div layout layout-fill>\n  <div layout=\"column\" layout-fill flex>\n    <main-header\n      class=\"mainHeader\"\n      flex=\"nogrow\"\n      ng-if=\"isLoggedin\"\n    ></main-header>\n\n    <div flex>\n      <div ui-view=\"view\" layout=\"column\" layout-fill></div>\n    </div>\n    <notification></notification>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/app.html
// module id = 711
// module chunks = 0